import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DrawerModule } from 'primeng/drawer';

@Component({
    selector: 'drawer',
    standalone: true,
    imports: [DrawerModule, TranslateModule],
    templateUrl: './drawer.component.html',
    styleUrl: './drawer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerComponent {
    isVisible = model.required<boolean>();
    id = input.required<string>();

    title = input<string | null>(null);
    position = input<'right' | 'left' | 'bottom' | 'top'>('right');
    showCloseIcon = input<boolean>(true);
    blockScroll = input<boolean>(true);
    closeOnEscape = input<boolean>(true);
    modal = input<boolean>(true);
    styleClass = input<string>('');
    size = input<'large' | 'x-large' | undefined>(undefined);

    onHide = output<void>();

    sizeWidth = computed(() => {
        switch (this.size()) {
            case 'large':
                return ' size-lg';
            case 'x-large':
                return ' size-x-lg';
            case undefined:
                return '';
        }
    });
}
